import React, { PropTypes } from 'react';
import ContractingPeriodSelection from '../../../../tc-ui/contractingPeriodsSelection';

const ContractingYear = ({
  onChange,
  startDate,
  endDate,
  label,
  required,
}) => {
  return (
    <div>
      <label><b>{label || `What dates would you like the rates to be valid for? `}</b></label>
      <span style={{ color: 'red', display: required ? 'inline-block' : 'none' }}>* Required</span>
      <br />
      <ContractingPeriodSelection
        onChange={(period) => {
          onChange('startDate', period.startDate);
          onChange('endDate', period.endDate);
        }}
        startDate={startDate}
        endDate={endDate}
        style={{ width: '90%', marginTop: '4px' }}
      />
    </div>
  );
};

ContractingYear.propTypes = {
  onChange: PropTypes.func,
  startDateError: PropTypes.string,
  endDateError: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

export default ContractingYear;



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/create-template-draft/components/contracting-year.jsx